import React from 'react'
import _ from 'lodash'
import styled from 'styled-components'

import List from 'pages/DeviceSearch/MultipleDevicesResults/List'
import SingleDeviceResult from 'pages/DeviceSearch/SingleDeviceResult'

import { color } from 'styles/colors'

type MultipleDevicesResultsProps = {
  pathRoot: string
  devices?: Record<string, unknown>[]
  invalidDeviceIds?: string[]
}

const MultipleDevicesResults = ({ pathRoot, devices = [], invalidDeviceIds = [] }: MultipleDevicesResultsProps) => {
  if ((devices && devices.length === 1) && _.isEmpty(invalidDeviceIds)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return <SingleDeviceResult device={devices[0] as any} />
  }

  return (
    <>
      {invalidDeviceIds?.length > 0 && (
        <>
          <S.InvalidIds>Devices not found: <span>{invalidDeviceIds.sort().join(', ')}</span></S.InvalidIds>
          <S.InvalidIdsTips>Please ensure the thermostat has been registered in Home and is connected to WIFI.</S.InvalidIdsTips>
        </>
      )}

      {devices && devices.length > 0 && (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        <List {...{ devices: devices as any, pathRoot }} />
      )}
    </>
  )
}

export default MultipleDevicesResults

const S = {
  ResultsTitle: styled.h2`
    margin-top: 40px;
    margin-bottom: 10px;
  `,
  InvalidIds: styled.div`
    margin-top: 30px;
    font-weight: bold;

    > span {
      color: ${color('errorText')};
    }
  `,
  InvalidIdsTips: styled.div`
    margin-bottom: 30px;
  `
}
